import { useDispatch } from 'react-redux';

import { IconMap } from '../../../shared/sprite';
import { Button, Icon } from '../../../shared/ui';

import { WORKSPACE_ROUTE } from '../../history';
import { navigate } from '../../../processes/navigation';
import { ReactNode } from 'react';

type Props = {
  text?: ReactNode;
};

const DEFAULT_TEXT =
  'The item you are looking for is available only to team members. Please request an invitation from the team owner or admin first.';

export const TeamOnlyAlert = ({ text = DEFAULT_TEXT }: Props) => {
  const dispatch = useDispatch();

  return (
    <div className="bg-base-white fixed inset-0 z-100 flex items-center justify-center p-4">
      <div className="text-center items-center flex flex-col gap-y-4 max-w-130">
        <Icon glyph={IconMap.DistributeLogoLetter} width={32} />
        <p className="text-lg text-gray-900">{text}</p>
        <Button
          variant="text"
          color="secondary"
          size="sm"
          onClick={() => {
            dispatch(
              navigate({ to: WORKSPACE_ROUTE, isKeepQueryParams: false })
            );
          }}
          className="font-semibold shadow-xs"
        >
          <Icon glyph={IconMap.ArrowLeft} className="mr-1.5" width={20} />
          Back to workspace
        </Button>
      </div>
    </div>
  );
};
